import React from 'react';
import PropTypes from 'prop-types';
import { localesShape } from '@spotahome/soyuz/shapes';
import { Footer as FooterComponent } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Heading.css';
import '@spotahome/ui-library/lib/components/footer/Footer.css';
import '@spotahome/ui-library/lib/components/LanguageSwitcher.css';
import '@spotahome/ui-library/lib/components/Link.css';
import '@spotahome/ui-library/lib/components/Separator.css';

import { updateURL } from '../utils/languageSwitcherUpdater';

import withAvailableLocales from './withAvailableLocales';

function handleHelpClick(e) {
  e.preventDefault();
  if (typeof zE !== 'undefined') {
    zE.activate({ hideOnClose: true });
  }
}

class Footer extends React.Component {
  static propTypes = {
    locales: PropTypes.shape(localesShape).isRequired,
    routing: PropTypes.shape({
      [PropTypes.string]: PropTypes.string
    }).isRequired
  };
  handleChange = selectedLocale => {
    updateURL(selectedLocale, this.props.routing);
  };

  render() {
    return (
      <FooterComponent
        help={{
          onClick: handleHelpClick
        }}
        locales={{
          current: this.props.locales.current,
          onChange: this.handleChange
        }}
      />
    );
  }
}

export default withAvailableLocales()(Footer);
